import { SWISSTOPO_GEOCODER_URL } from '@/constants';
import axios from 'axios';

export const searchLocationRequest = (query: string): Promise<Record<string, unknown>> => {
  return axios.get(`${SWISSTOPO_GEOCODER_URL}?searchText=${query}&type=locations&sr=4326`)
}